export class UserDetails {
  public id!: string;
  public userName!: string;
  public firstName!: string;
  public email!: string;
  public lastName!: string;
  public groupId!: number;
  public isAdmin!: boolean;
}
